


























import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'

@Component
export default class PresenterSearchResultsSession extends Vue {
  date: Json = {}

  @Prop()
  readonly item!: Json

  get name () {
    return date.formatDate(new Date(this.item.createdAt), 'dddd D MMM \'YY, HH:mm')
  }

  click () {
    if (!this.item.deletedAt) {
      this.$emit('select')
      if (+this.$route.params.id !== this.item.id) {
        this.$router.replace('/presenter/session/'+this.item.id)
      }
    }
  }
}
